import { render, staticRenderFns } from "./PaginaInicial.vue?vue&type=template&id=cc45a244&scoped=true&"
import script from "./PaginaInicial.vue?vue&type=script&lang=js&"
export * from "./PaginaInicial.vue?vue&type=script&lang=js&"
import style0 from "./PaginaInicial.vue?vue&type=style&index=0&id=cc45a244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc45a244",
  null
  
)

export default component.exports